var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ob1-search-field", {
    attrs: {
      id: "search-field",
      label: _vm.placeHolder,
      "show-auto-completion": _vm.showAutoCompletion,
    },
    on: { input: _vm.inputSearchFiledHandler },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }